<template>
  <div v-if="auth == 'loggedin' || token != null || token != undefined">
    <b-row>
      <b-col class="col-sm-12 mt-2" style="text-align: center">
        <h2 class="h2bevetelzes">Bevételezés szerkesztése</h2>
      </b-col>
    </b-row>

    <b-row>
      <!-- SZÁLLÍTÓLEVÉL ADATOK -->
      <b-col>
          <b-card
            border-variant="secondary"
            class="text-center mt-1">
            <b-card-body class="text-left">
              <h3 class="h3bevetelzes">Szállítólevél adatok</h3>
              <b-row>
                <!-- BESZERZÉS DÁTUA -->
                <b-col>
                  <div class="form-group">
                    <label for="beszerdatum">Beszerzés dátuma*</label>
                    <b-form-input
                      ref="beszerzesDatum"
                      size="sm"
                      type="date"
                      v-model="keszletFej.beszerzesDatum"
                      class="form-control"
                      id="beszerdatum"
                      required
                    />
                  </div>
                </b-col>
                <!-- RAKTÁR -->
                <b-col>
                  <div>
                    <label for="raktar">Raktár*</label>
                    <b-form-select
                      v-model="raktarSelect"
                      :options="raktarList"
                      @change="keszletFej.raktarId = raktarSelect.id"
                      size="sm"
                      id="raktar">
                      required
                    </b-form-select>
                  </div>
                </b-col>
                <!-- BIZONYLATSZÁM -->
                <b-col>
                  <div class="form-group">
                    <label for="garancia">Bizonylatszám*</label>
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="keszletFej.bizszam"
                      class="form-control"
                      id="garancia"
                      required
                    />
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
      </b-col>
      <!-- SZÁLLÍTÓ ADATOK -->
      <b-col>
          <b-card
            border-variant="secondary"
            class="text-center mt-1">
            <b-card-body class="text-left">
              <h3 class="h3bevetelzes">Szállító adatok</h3>
              <b-row>
                <!-- PARTNER -->
                <b-col>
                  <div>
                    <b-button-group>
                      <label for="forras">Partner*</label>
                      <vue-typeahead-bootstrap
                        class="text-left"
                        :maxMatches="100"
                        :minMatchingChars="1"
                        :disabled="isDisabled == 1"
                        size="sm"
                        :data="forrasList"
                        v-model="forrasSelect.nev"
                        :serializer="item => item.nev"
                        @hit="forrasSelect = $event"
                        placeholder="Keresés partner neve"
                        />
                      <b-button
                        size="sm"
                        class="btn float-right"
                        variant="outline-danger"
                        @click="partnerChange()"
                        ><b-icon-x-circle></b-icon-x-circle>
                      </b-button>
                    </b-button-group>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <!-- IRSZÁM -->
                <b-col>
                  <div>
                    <label for="irszam">Irányítószám</label>
                    <b-form-input
                      :disabled="isDisabled == 1"
                      v-model="forrasSelect.irszam"
                      size="sm"
                      id="irszam">
                    </b-form-input>
                  </div>
                </b-col>
                <!-- VÁROS -->
                <b-col>
                  <div>
                    <label for="varos">Város</label>
                    <b-form-input
                      :disabled="isDisabled == 1"
                      v-model="forrasSelect.varos"
                      size="sm"
                      id="varos">
                    </b-form-input>
                  </div>
                </b-col>
                <!-- Cím -->
                <b-col>
                  <div>
                    <label for="cim">Cím</label>
                    <b-form-input
                      :disabled="isDisabled == 1"
                      v-model="forrasSelect.cim"
                      size="sm"
                      id="cim">
                    </b-form-input>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <!-- Adószám -->
                <b-col>
                  <div>
                    <label for="adoszam">Adószám</label>
                    <b-form-input
                      :disabled="isDisabled == 1"
                      v-model="forrasSelect.adoszam"
                      size="sm"
                      id="adoszam">
                    </b-form-input>
                  </div>
                </b-col>
                <!-- Email -->
                <b-col>
                  <div>
                    <label for="email">Email</label>
                    <b-form-input
                      :disabled="isDisabled == 1"
                      v-model="forrasSelect.email"
                      size="sm"
                      id="email">
                    </b-form-input>
                  </div>
                </b-col>
                <!-- Telefon -->
                <b-col>
                  <div>
                    <label for="telefon">Telefon</label>
                    <b-form-input
                      :disabled="isDisabled == 1"
                      v-model="forrasSelect.telefon"
                      size="sm"
                      id="telefon">
                    </b-form-input>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
      </b-col>
    </b-row>

    <!-- KERESÉS -->
    <!-- <b-card
      border-variant="secondary"
      class="text-center mt-1">
      <b-card-body class="text-left">

        <b-row>
          <div class="col-sm-12" >
            <div class="row">

              <div>
                <b-button-group>
                  <b-button
                    size="sm"
                    class="btn float-left"
                    variant="outline-danger"
                    @click="searchText='', filterSelect='', search()"
                    ><b-icon-x-circle></b-icon-x-circle>
                  </b-button>

                  <b-form-select
                    size="sm"
                    v-model="filterSelect"
                    :options="filters"
                    class="form-control"
                    id="td"
                  ></b-form-select>
                </b-button-group>
              </div>

              <div class="col-sm-2">
                <b-form-input
                  size="sm"
                  class="form-control"
                  ref="searchInput"
                  v-model="searchText"
                  id="search"
                  @click="searchText=''"
                  @keyup.enter="search()"
                  placeholder="vonalkod, terméknév, cikkszám"
                ></b-form-input>
              </div>

              <div>
                <b-button
                  size="sm"
                  class="btn float-left"
                  variant="success"
                  @click="search()"
                  ><b-icon-search></b-icon-search>
                  Keresés
                </b-button>
              </div>

            </div>
          </div>
        </b-row>

      </b-card-body>
    </b-card> -->

    <b-row>
      <b-col>
        <b-form-group>
          <b-button
            v-b-modal.modal-xl
            size="sm"
            variant="success"
            class="btn float-left"
            @click="bevMode = 1"
            ><b-icon-plus-circle></b-icon-plus-circle>
            Új cikk létrehozása
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- TÉTEL HOZZÁADÁS FELÜLET -->
    <b-card
      border-variant="secondary"
      class="text-center mt-1"
    >
    <b-row>
      <b-col>
        <div>
          <label for="forras" class="float-left">Megnevezés*</label>
          <vue-typeahead-bootstrap
            class="text-left"
            :maxMatches="100"
            :minMatchingChars="1"
            ref="megnevezes_typeahead"
            size="sm"
            :data="cikkekList"
            :serializer="item => `${item.nev} - vonalkód: ${item.vonalkod} - cikkszám: ${item.cikkszam} -  készlet: ${item.mennyiseg} -  fogyár: ${item.bruttofogyar} Ft`"
            @hit="cikkSelect = $event"
            placeholder="terméknév, vonalkod, cikkszám"
            />
        </div>
      </b-col>
        <b-col class="col-sm-1">
          <b-form-group style="color: white;" label="." label-for="hozzáadása"  label-align-sm="left">
            <b-button
              size="sm"
              variant="outline-danger"
              class="btn float-left"
              @click="clearFejtetel"
              ><b-icon-x-circle></b-icon-x-circle>
            </b-button>
          </b-form-group>
        </b-col>
    </b-row>
      <b-row class="mt-3">
        <!-- <b-col> -->
            <!-- <div> -->
              <!-- <v-select
                label="nev"
                :options="cikkekList"
                model="cikkSelect"
              ></v-select> -->
              <!-- <label for="forras">Megnevezés</label>
              <v-select
                ref="forras"
                :loading="cikkekList.length <= 0"
                v-model="cikkSelect"
                :options="cikkekList"
                key="id"
                label="nev"
                @input="onInput"
                placeholder="Keresés vonalkod, terméknév">
                <template #spinner="{ loading }">
                  <div v-if="loading" class="vs__spinner" />
                </template>
              </v-select> -->
              <!-- <label for="forras">Megnevezés</label>
              <vue-typeahead-bootstrap
                size="sm"
                ref="forras"
                :data="cikkekList"
                :serializer="item => item.nev"
                @hit="cikkSelect = $event"
                @keyup.enter="fillCikkData"
                placeholder="Keresés vonalkod, terméknév"
                /> -->
            <!-- </div> -->

        <!-- </b-col> -->

        <b-col>
          <b-form-group label="Mennyiség" label-for="darab"  label-align-sm="left">
            <b-form-input size="sm" type="number"
            ref="mennyiseg"
            @keyup="getVegOsszeg"
            @keyup.enter="addFejtetel"
            v-model="cikkTemp.darab" class="form-control" id="darab"></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Nettó beszerzési ár" label-for="nettobeszar"  label-align-sm="left">
            <b-form-input size="sm" type="number" step="0.01" @keyup="getVegOsszeg" v-model="cikkTemp.nettobeszar" class="form-control" id="nettobeszar"></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Bruttó fogyár" label-for="bruttofogyar"  label-align-sm="left">
            <b-form-input size="sm" type="number" @keyup="getVegOsszeg" v-model="cikkTemp.bruttofogyar" class="form-control" id="bruttofogyar"></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Nettó összesen" label-for="sorosszesen"  label-align-sm="left">
            <b-form-input
            size="sm"
            type="number"
            v-model="cikkTemp.sorosszesen"
            class="form-control"
            id="sorosszesen"
            disabled></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Vonalkód" label-for="vonalkod"  label-align-sm="left">
            <b-form-input
            size="sm"
            type="text"
            v-model="cikkTemp.vonalkod"
            class="form-control"
            id="vonalkod"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Cikkszám" label-for="cikkszam"  label-align-sm="left">
            <b-form-input
            size="sm"
            type="text"
            v-model="cikkTemp.cikkszam"
            class="form-control"
            id="cikkszam"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Készleten" label-for="keszleten"  label-align-sm="left">
            <b-form-input
            size="sm"
            type="text"
            v-model="cikkTemp.keszleten"
            class="form-control"
            id="keszleten"
            disabled></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Műveletek" label-for="hozzáadás"  label-align-sm="left">
            <b-button
              size="sm"
              variant="primary"
              class="btn float-left"
              @click="addFejtetel"
              ><b-icon-plus-circle></b-icon-plus-circle>
              Hozzáadás
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- <b-row>
        <h4>forrasSelect</h4>
        {{forrasSelect}}
      </b-row>
      <b-row>
        <h4>keszletFej</h4>
        {{keszletFej}}
      </b-row>
      <b-row>
        <h4>cikkSelect</h4>
        {{cikkSelect}}
      </b-row>
      <b-row>
        <h4>cikkTemp</h4>
        {{cikkTemp}}
      </b-row>
      <b-row>
        <h4>keszletTetel</h4>
        {{keszletTetel}}
      </b-row> -->
      <!-- <b-row>
        | cikkekList
        {{cikkekList}}
      </b-row> -->

      <!-- // TABLE -->
      <div class="mt-3">
        <b-table class="labelsize table-striped" hover :items="keszletTetel" :fields="fields" :key="keszletTetel.cikkid">

          <!-- // MENNYISÉG -->
          <template v-slot:cell(darab)="row" class="mb-1">
              <b-button
                v-if="!row.item.gyariszamos"
                size="sm"
                @click="getMinus(row)"
                variant="primary"
                class="mr-1"
                ><b-icon-dash>-</b-icon-dash>
              </b-button>
              {{row.item.darab}}
              <b-button
                v-if="!row.item.gyariszamos"
                size="sm"
                @click="getPlus(row)"
                variant="primary"
                class="mr-1"
                ><b-icon-plus></b-icon-plus>
              </b-button>
          </template>

          <!-- // SHOW SERIAL NUMBERS -->
          <template v-if="userType=='admin'" v-slot:cell(serialNumbersLabel)="row">
            <div v-show=" row.item.serialNumbersLabel.length > 0">
              {{row.item.serialNumbersLabel}}
            </div>
          </template>

          <!-- // EDIT -->
          <template v-if="userType=='admin'" v-slot:cell(edit)="row">
            <b-button
              v-b-modal.edit-product
              size="sm"
              @click="bevMode = 2, itemId = row.item.cikkid"
              variant="outline-success"
              class="mr-1"
              ><b-icon-pencil></b-icon-pencil>
            </b-button>
          </template>

          <!-- // DELETE -->
          <template v-if="userType=='admin'" v-slot:cell(del)="row">
            <b-button
              size="sm"
              @click="showMsgBoxTwo(row)"
              variant="outline-danger"
              class="mr-1"
              ><b-icon-trash></b-icon-trash>
            </b-button>
          </template>

        </b-table>
      </div>
    </b-card>
    <b-card
      border-variant="secondary"
      class="text-center mt-1"
    >
      <b-row>
        <b-col>
          <h2 class="h2bevetelzes">
            Nettó végösszeg: {{summa}}
          </h2>
        </b-col>
      </b-row>
    </b-card>
    <b-card
      border-variant="secondary"
      class="text-center mt-1"
    >
      <b-row>
        <b-col>
          <!-- // SAVE -->
          <b-button
            variant="primary"
            @click='keszletSave'
            type="submit"
            class="float-left">
            <b-icon-cloud-upload></b-icon-cloud-upload>
            Bevételezés mentése
          </b-button>
        </b-col>
        <b-col>
          <!-- // CANCEL -->
          <b-button
            variant="outline-danger"
            class="float-right"
            @click="
              $router.push({
                name: 'Keszlet'
              })
            "
            ><b-icon-arrow-left></b-icon-arrow-left>
            Mégsem
            </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-modal id="modal-xl" size="xl" title="" hide-footer hide-header>
      <CikkekNew :bevmode="bevMode" :itemId="itemId" @update-number="update" @close-product="closeProduct"/>
    </b-modal>
    <b-modal id="edit-product" size="xl" title="" hide-footer hide-header>
      <CikkekNew :bevmode="bevMode" :itemId="itemId" @edit-product="editProduct" @close-product="closeProduct"/>
    </b-modal>

    <!-- GYÁRISZÁM MODÁL -->
    <b-modal
      id="serials-modal"
      size="xl"
      title="Add meg a gyártási számokat"
      @shown="serialsModalFocus"
      @ok="serialSave($event)"
      @cancel="serialCancel($event)"
      >
      <div>
        <b-form-group
          id="fieldset-horizontal"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label="Megnevezés:"
        >
          {{serialNumbersHead.nev}}
        </b-form-group>
        <b-form-group
          id="fieldset-horizontal"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label="Vonalkód:"
        >
          {{serialNumbersHead.vonalkod}}
        </b-form-group>
        <b-form-group
          mt-1
          id="fieldset-horizontal"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label="Cikkszám:"
        >
          {{serialNumbersHead.cikkszam}}
        </b-form-group>
      </div>
      <!-- <p>{{serialNumbers}}</p> -->
      <p>Gyártási számok:</p>
      <div>
        <b-form-input
        v-model="serialNumbersInput"
        ref="serialsModal"
        @keyup.enter="serialsModal"
        >
        </b-form-input>

      </div>
      <p class="mt-1">{{serialNumbersLabel}}</p>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import {debounce} from 'lodash'

export default {
  components: {
    CikkekNew: () => import('./CikkekNew')
  },
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      proba: ['aaa', 'bbb', 'ccc'],
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      cikkShow: true,
      list: [],
      lastKeszletFej: [],
      keszletFej: {
        beszerzesDatum: '',
        beszallitoId: '',
        raktarId: '',
        bizszam: ''
      },
      keszletTetel: [],
      forrasSelect: {
        id: '',
        nev: '',
        irszam: null,
        varos: '',
        cim: '',
        telefon: '',
        email: '',
        kategoria: '',
        adoszam: ''
      },
      forrasList: [],
      query: '',
      raktarSelect: [],
      raktarList: [],
      cikkekList: [],
      cikkSelect: [],
      cikkTemp: {
        cikkid: '',
        nev: '',
        sorosszesen: '',
        nettobeszar: '',
        bruttofogyar: '',
        darab: '',
        vonalkod: '',
        cikkszam: '',
        keszleten: ''
      },
      searchText: '',
      filterSelect: '',
      isDisabled: 0,
      bizszam: '',
      filters: [
        'Minden oszlop',
        'Megnevezés'
      ],
      fields: [
        {
          key: 'cikkid',
          label: 'Id',
          sortable: true,
          sortDirection: 'desc'
        },
        // {
        //   key: 'createdAt',
        //   formatter: (value, key, item) => {
        //     return moment(String(value)).format('YYYY-MM-DD')
        //   }
        // },
        {
          key: 'nev',
          label: 'Megnevezés',
          sortable: true,
          sortDirection: 'desc'
          // thClass: 'text-left'
        },
        {
          key: 'darab',
          label: 'Mennyiség',
          sortable: true,
          sortDirection: 'desc'
          // thClass: 'text-left'
        },
        {
          key: 'nettobeszar',
          label: 'Nettó besz. ár',
          sortable: true,
          sortDirection: 'desc'
          // thClass: 'text-left'
        },
        {
          key: 'bruttofogyar',
          label: 'Bruttó fogy.ár',
          sortable: true,
          sortDirection: 'desc'
          // thClass: 'text-left'
        },
        {
          key: 'osszesen',
          label: 'Összesen',
          sortable: true,
          sortDirection: 'desc'
          // thClass: 'text-left'
        },
        {
          key: 'cikkszam',
          label: 'Cikkszám',
          sortable: true,
          sortDirection: 'desc'
          // thClass: 'text-left'
        },
        {
          key: 'vonalkod',
          label: 'Vonalkód',
          sortable: true,
          sortDirection: 'desc'
          // thClass: 'text-left'
        },
        {
          key: 'keszleten',
          label: 'Készleten',
          sortable: true,
          sortDirection: 'desc'
          // thClass: 'text-left'
        },
        // { key: 'send', sortable: false },
        // { key: 'munkalap', sortable: false },
        { key: 'serialNumbersLabel',
          label: ''
        },
        { key: 'edit',
          label: '',
          sortable: false
        },
        { key: 'del',
          label: '',
          sortable: false
        }
      ],
      summa: 0,
      bevMode: 0,
      itemId: 0,
      newProduct: '',
      serialNumbersHead: '',
      serialNumbersInput: '',
      serialNumbersLabel: [],
      serialNumbers: []
    }
  },
  methods: {
    serialSave (bvModalEvent) {
      console.log('Save')
    },
    serialCancel (bvModalEvent) {
      // bvModalEvent.preventDefault()
      this.serialNumbersInput = ''
      this.serialNumbersLabel = []
      this.serialNumbers = []
      this.clearFejtetel()
      this.cikkSelect = []
      this.$bvModal.hide('serials-modal')
      console.log('Cancel')
    },
    serialsModalFocus: function () {
      this.serialNumbersHead = this.cikkSelect
      this.serialNumbersInput = ''
      this.serialNumbersLabel = []
      this.$refs.serialsModal.focus()
    },
    serialsModal: function () {
      console.log('serialsModal')
      if (this.serialNumbersInput !== '') {
        this.serialNumbers.push({
          cikkid: this.cikkSelect.id,
          value: this.serialNumbersInput
        })
        this.serialNumbersLabel.push(this.serialNumbersInput)
        this.serialNumbersInput = ''
        this.$refs.serialsModal.focus()
      } else {
        this.$refs.serialsModal.focus()
      }
    },
    closeProduct: function (data) {
      this.bevMode = 0
    },
    editProduct: function (data) {
      this.loadList()
      this.newProduct = data
      for (var index in this.keszletTetel) {
        if (this.keszletTetel[index].cikkid === data.id) {
          this.keszletTetel[index].bruttofogyar = this.newProduct.bruttofogyar
          this.keszletTetel[index].cikkszam = this.newProduct.cikkszam
          this.keszletTetel[index].keszleten = this.newProduct.mennyiseg
          this.keszletTetel[index].nettobeszar = this.newProduct.nettobeszar
          this.keszletTetel[index].nev = this.newProduct.nev
          this.keszletTetel[index].vonalkod = this.newProduct.vonalkod
          this.keszletTetel[index].gyariszamos = this.newProduct.gyariszamos
          this.keszletTetel[index].osszesen = parseInt(this.keszletTetel[index].bruttofogyar) * parseInt(this.keszletTetel[index].darab)
          this.getSumma()
        }
      }
      this.$bvModal.hide('edit-product')
      this.clearFejtetel()
      this.bevMode = 0
      // this.$refs.megnevezes_typeahead.inputValue = this.newProduct.nev + ' - vonalkód: ' + this.newProduct.vonalkod + ' - cikkszám: ' + this.newProduct.cikkszam + ' -  készlet: ' + this.newProduct.mennyiseg + ' -  fogyár: ' + this.newProduct.bruttofogyar + ' Ft'
      // this.$refs.mennyiseg.focus()
    },
    update: function (data) {
      console.log('data  ---  update')
      console.log(data)
      this.newProduct = data
      this.cikkekList.push(this.newProduct)
      this.cikkSelect = this.newProduct
      this.$bvModal.hide('modal-xl')
      this.$refs.megnevezes_typeahead.inputValue = this.newProduct.nev + ' - vonalkód: ' + this.newProduct.vonalkod + ' - cikkszám: ' + this.newProduct.cikkszam + ' -  készlet: ' + this.newProduct.mennyiseg + ' -  fogyár: ' + this.newProduct.bruttofogyar + ' Ft'
      this.$refs.mennyiseg.focus()
      this.bevMode = 0
      if (this.cikkSelect.id && parseInt(this.cikkSelect.gyariszamos) === 1) {
        this.$bvModal.show('serials-modal')
      }
      this.fillCikkData()
      this.getSumma()
    },
    getMinus (e) {
      let index = e.index
      console.log(index)
      if (parseInt(this.keszletTetel[index].darab) === 1) {
        this.flashMessage.error({ title: 'Figyelem!', message: 'A darambszám nem lehet egynél kisebb!' })
      } else {
        this.keszletTetel[index].darab = parseInt(this.keszletTetel[index].darab) - 1
        this.keszletTetel[index].osszesen = parseInt(this.keszletTetel[index].bruttofogyar) * parseInt(this.keszletTetel[index].darab)
        this.getSumma()
      }
    },
    getPlus (e) {
      let index = e.index
      console.log(this.keszletTetel[index])
      this.keszletTetel[index].darab = parseInt(this.keszletTetel[index].darab) + 1
      this.keszletTetel[index].osszesen = parseInt(this.keszletTetel[index].bruttofogyar) * parseInt(this.keszletTetel[index].darab)
      this.getSumma()
    },
    partnerChange () {
      console.log('HI')
      this.isDisabled = 0
      this.forrasSelect.id = ''
      this.forrasSelect.nev = ''
      this.forrasSelect.irszam = ''
      this.forrasSelect.varos = ''
      this.forrasSelect.cim = ''
      this.forrasSelect.telefon = ''
      this.forrasSelect.email = ''
      this.forrasSelect.kategoria = ''
      this.forrasSelect.adoszam = ''
    },
    onInput () {
      console.log(this.selected)
    },
    loadList () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        // Beszerzési források
        axios.post(process.env.ROOT_API + '/partner/getlist', {payload}).then((res) => {
          this.forrasList = res.data
        }).catch((err) => {
          console.log(err)
        })
        // Raktárak
        axios.post(process.env.ROOT_API + '/raktarak/getlist', {payload}).then((res) => {
          for (var el in res.data) {
            this.raktarList.push(
              {
                value: res.data[el],
                text: res.data[el].megnevezes
              })
            if (res.data[el].default === 1) {
              this.raktarSelect = res.data[el]
            }
          }
        }).catch((err) => {
          console.log(err)
        })
        // Cikkek
        axios.post(process.env.ROOT_API + '/cikkek/getquicksearchlist', {payload}).then((res) => {
          this.cikkekList = res.data
        }).catch((err) => {
          console.log(err)
        })
        // Készlet
        axios.post(process.env.ROOT_API + '/keszlet/getlast', {payload}).then((res) => {
          this.lastKeszletFej = res.data
          this.keszletFej.beszerzesDatum = moment(res.data[0].beszerdatum).format('YYYY-MM-DD')
          this.keszletFej.bizszam = res.data[0].bizszam
          this.keszletFej.raktarId = res.data[0].id
          this.forrasSelect = res.data[0].partner
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    addFejtetel () {
      let obj = this.keszletTetel.find(o => o.cikkid === this.cikkTemp.cikkid)
      if (obj) {
        for (var el in this.serialNumbers) {
          obj.serialNumbers.push(this.serialNumbers[el])
          obj.serialNumbersLabel.push(this.serialNumbersLabel[el])
        }
        if (obj.serialNumbers.length) {
          obj.darab = parseInt(obj.serialNumbers.length)
        } else {
          obj.darab = parseInt(obj.darab) + parseInt(this.cikkTemp.darab)
        }
        obj.osszesen = parseInt(obj.osszesen) + parseInt(this.cikkTemp.sorosszesen)
      } else {
        if (this.cikkTemp.nev !== '') {
          if (this.serialNumbers.length > 0) {
            this.cikkTemp.darab = parseInt(this.serialNumbers.length)
          }

          this.keszletTetel.push({
            cikkid: this.cikkTemp.cikkid,
            nev: this.cikkTemp.nev,
            sorosszesen: this.cikkTemp.sorosszesen,
            nettobeszar: this.cikkTemp.nettobeszar,
            bruttofogyar: this.cikkTemp.bruttofogyar,
            osszesen: this.cikkTemp.sorosszesen,
            darab: this.cikkTemp.darab,
            vonalkod: this.cikkTemp.vonalkod,
            cikkszam: this.cikkTemp.cikkszam,
            keszleten: this.cikkTemp.keszleten,
            serialNumbers: this.serialNumbers,
            serialNumbersLabel: this.serialNumbersLabel,
            gyariszamos: this.cikkTemp.gyariszamos
          })
        }
      }
      this.serialNumbers = []
      this.serialNumbersLabel = []
      this.cikkTemp = {
        cikkid: '',
        nev: '',
        sorosszesen: '',
        nettobeszar: '',
        bruttofogyar: '',
        darab: '',
        vonalkod: '',
        cikkszam: '',
        keszleten: '',
        gyariszamos: ''
      }
      this.cikkSelect = []
      this.$refs.megnevezes_typeahead.inputValue = ''
      // this.$refs.megnevezes_typeahe.focus()
      this.getSumma()
      // this.$refs.forras.inputValue = ''
      // this.$refs.forras.open = false
    },
    clearFejtetel () {
      this.$refs.megnevezes_typeahead.inputValue = ''
      this.cikkTemp = {
        cikkid: '',
        nev: '',
        sorosszesen: '',
        nettobeszar: '',
        bruttofogyar: '',
        darab: '',
        vonalkod: '',
        cikkszam: '',
        keszleten: '',
        gyariszamos: ''

      }
      this.serialNumbers = []
    },
    search () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        if (this.searchText !== '') {
          payload.token = this.token
          payload.userType = this.userType
          payload.filter = this.filterSelect
          payload.searchText = this.searchText
          axios.post(process.env.ROOT_API + '/cikkek/search', {payload})
            .then(res => {
              res.data[0].cikkid = res.data[0].id
              res.data[0].darab = 1
              res.data[0].keszleten = res.data[0].mennyiseg
              res.data[0].osszesen = res.data[0].nettobeszar
              res.data[0].sorosszesen = res.data[0].nettobeszar
              delete res.data[0].order
              delete res.data[0].gyariszamos
              delete res.data[0].gyartoid
              delete res.data[0].hidden
              delete res.data[0].mennyiseg
              delete res.data[0].mennyisegiegyseg
              delete res.data[0].updatedAt
              delete res.data[0].id
              delete res.data[0].closed
              delete res.data[0].createdAt
              delete res.data[0].csikcsoportid
              this.getVegOsszeg()

              let obj = this.keszletTetel.find(o => o.cikkid === res.data[0].cikkid)

              if (obj) {
                obj.darab = parseInt(obj.darab) + 1
                obj.osszesen = parseInt(obj.osszesen) + parseInt(res.data[0].osszesen)
              } else {
                this.keszletTetel.push(res.data[0])
              }
              this.getSumma()
              // this.$refs.searchInpfocus()
              this.searchText = ''
            })
            .catch(err => {
              console.log(err)
            })
        }
      }
    },
    keszletSave () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        if (!this.keszletFej.beszerzesDatum || !this.forrasSelect.nev || !this.keszletFej.raktarId || !this.keszletFej.bizszam) {
          this.flashMessage.warning({ title: 'Hiba!', message: 'Nincs kitöltve minden * -al jelölt kötelező mező!' })
        } else {
          if (this.keszletTetel.length > 0) {
            payload.token = this.token
            payload.userType = this.userType
            payload.forrasSelect = this.forrasSelect
            payload.summa = this.summa
            payload.keszletFej = this.keszletFej
            payload.keszletTetel = this.keszletTetel
            axios
              .post(process.env.ROOT_API + '/keszlet/save', { payload })
              .then(res => {
                this.$router.push({ name: 'Keszlet' })
                this.flashMessage.success({ title: 'Gratulálunk!', message: 'Az adatokkat sikeresem mentésre kerültek!' })
              })
              .catch(err => {
                console.log(err)
              })
          } else {
            this.flashMessage.warning({ title: 'Hiba!', message: 'Adj hozzás legalább egy terméket a terméklistához!' })
          }
        }
      }
    },
    fillCikkData () {
      if (this.cikkSelect.id) {
        this.cikkTemp.cikkid = this.cikkSelect.id
        this.cikkTemp.nev = this.cikkSelect.nev
        this.cikkTemp.nettobeszar = this.cikkSelect.nettobeszar
        this.cikkTemp.bruttofogyar = this.cikkSelect.bruttofogyar
        this.cikkTemp.darab = 1
        this.cikkTemp.vonalkod = this.cikkSelect.vonalkod
        this.cikkTemp.cikkszam = this.cikkSelect.cikkszam
        this.cikkTemp.keszleten = this.cikkSelect.mennyiseg
        this.cikkTemp.gyariszamos = this.cikkSelect.gyariszamos
        this.getVegOsszeg()
      // this.$refs.darfocus()
      }
    },
    getVegOsszeg () {
      this.cikkTemp.sorosszesen = this.cikkTemp.nettobeszar * this.cikkTemp.darab
    },
    getSumma () {
      this.summa = 0
      for (let el in this.keszletTetel) {
        this.summa += parseInt(this.keszletTetel[el].osszesen)
      }
    },
    showMsgBoxTwo (row) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('(Megnevezés:  ' + row.item.nev + ') ', {
          title: 'Biztos törlöni akarod?',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.keszletTetel.splice(row.index, 1)
            for (var el in this.serialNumbers) {
              if (this.serialNumbers[el].cikkid === row.item.cikkid) {
                this.serialNumbers.splice(el)
                console.log(el)
              }
            }

            this.getSumma()
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  mounted: function () {
    this.loadList()
  },
  watch: {
    cikkSelect: function () {
      if (this.cikkSelect.id && this.cikkSelect.gyariszamos === 1) {
        this.$bvModal.show('serials-modal')
      }
      this.fillCikkData()
      this.getSumma()
    },
    forrasSelect: function () {
      this.isDisabled = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/KeszletNew.vue